import Vue from 'vue'
import InstantSearch from 'vue-instantsearch'

Vue.use(InstantSearch)
